import { Col } from 'antd';
import { useSelector } from 'react-redux';
import { Loader } from 'zComponents/atoms';
import { AddSiteModal } from 'zComponents/molecules';
import { Flex, Row, Typography } from 'zui/Antd';
import SiteFloorAccordion from './components/SiteFloorAccordion';

const { Title } = Typography;
function SitesAndFloorsSettings() {
	// Redux state
	const { loading: loadingSites } = useSelector((state) => state.Sites);

	return (
		<Row gutter={[16, 16]}>
			<Col span={24}>
				<Flex justify='space-between' align='center' wrap gap={16}>
					<Title level={4} style={{ margin: 0 }}>
						Site Management
					</Title>
					<AddSiteModal />
				</Flex>
			</Col>
			<Col span={24}>{loadingSites ? <Loader /> : <SiteFloorAccordion />}</Col>
		</Row>
	);
}

export default SitesAndFloorsSettings;
